import useSWR from "swr";
import { useAuth } from "@/auth/auth";
import type { components } from "./zz_schema";

export type IOSSnapshot = components["schemas"]["IOSSnapshot"];
export const iosSnapshotPageSize = 25;

export function useOrganizationIOSSnapshots(organizationId: string | undefined, prefix: string, offset: number) {
  const auth = useAuth();
  return useSWR(organizationId ? ["ios-snapshots", organizationId, prefix, offset] : null, async () => {
    if (!organizationId) return undefined;
    const { data, error } = await auth.client.GET("/v1/organizations/{organizationId}/ios_snapshots", {
      params: { path: { organizationId }, query: { prefix, offset, limit: iosSnapshotPageSize } },
    });
    if (error) throw new Error(error.message);
    return data;
  });
}

export function useOrganizationIOSSnapshot(organizationId: string | undefined, key: string) {
  const auth = useAuth();
  return useSWR(organizationId ? ["ios-snapshot", organizationId, key] : null, async () => {
    if (!organizationId) return undefined;
    const { data, error, response } = await auth.client.GET("/v1/organizations/{organizationId}/ios_snapshots/{key}", {
      params: { path: { organizationId, key } },
    });
    if (response.status === 404) return null;
    if (error) throw new Error(error.message);
    return data;
  });
}
